import React from "react";
import { X, ArrowCounterClockwise } from "phosphor-react";
import { InputCurrencyWithSuffixFloatingLabelHelpers } from "./Shared";
import parseDecimal from "../../utils/helpers/parseDecimal";

export function CurrencyInput({
  label,
  value,
  setValue,
  initialValue,
  suffix,
  validate,
  disabled = false,
}) {
  return (
    <InputCurrencyWithSuffixFloatingLabelHelpers
      value={value}
      onValueChange={(e) => {
        const { floatValue } = e;
        setValue(parseDecimal(floatValue));
      }}
      label={label}
      id={label}
      suffix={suffix}
      helpers={[
        <X weight="thin" size={14} onClick={() => setValue(0)} />,
        <ArrowCounterClockwise
          weight="thin"
          size={14}
          onClick={() => setValue(initialValue)}
        />,
      ]}
      validate={validate}
      disabled={disabled}
    />
  );
}
